import appActionTypes from "../constants/types";

export const initialState = {
  data: [],
  isLoading: false,
  message: null,
  errorMessage: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case appActionTypes.product_channel.get.requested:
    case appActionTypes.product_channel.create.requested:
    case appActionTypes.product_channel.delete.requested:
    case appActionTypes.product_channel.edit.requested:
      return {
        ...state,
        isLoading: true,
        message: action.message,
        errorMessage: null
      };
    case appActionTypes.product_channel.get.success:
      return {
        ...state,
        data: action.data,
        isLoading: false,
        message: action.message,
        errorMessage: null,
      };
      
    case appActionTypes.product_channel.create.success:
      var _list = JSON.parse(JSON.stringify(state.data))
      _list.push(action.data);
      return {
        ...state,
        data: _list,
        isLoading: false,
        message: action.message,
        errorMessage: null,
      };

    case appActionTypes.product_channel.delete.success:
      var _list = JSON.parse(JSON.stringify(state.data))
      var index = _list.findIndex((obj) => obj._id === action.data?._id);
      if (index !== -1) _list.splice(index, 1);

      return {
        ...state,
        data: _list,
        isLoading: false,
        message: action.message,
        errorMessage: null,
      };
      
    case appActionTypes.product_channel.edit.success:
      var _list = JSON.parse(JSON.stringify(state.data))
      var index = _list.findIndex((obj) => obj._id === action.data?._id);
      if (index !== -1) _list[index] = action.data;

      return {
        ...state,
        data: _list,
        isLoading: false,
        message: action.message,
        errorMessage: null,
      };
    case appActionTypes.product_channel.get.fail:
    case appActionTypes.product_channel.create.fail:
    case appActionTypes.product_channel.delete.fail:
    case appActionTypes.product_channel.edit.fail:
      return {
        ...state,
        isLoading: false,
        message: null,
        errorMessage: action.errorMessage,
      };
    default:
      return state;
  }
};
